import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './scss/style.scss'
import {
  Route, createBrowserRouter, createRoutesFromElements, RouterProvider
} from 'react-router-dom';
import Home from '../src/container/Home/Home';
import AboutMe from '../src/container/AboutMe/AboutMe';
import CaseStudy from '../src/container/CaseStudy/CaseStudy';
import DummyPro from '../src/container/DummyPro/DummyPro';
import Contact from '../src/container/Contact/Contact';
import CaseStudydetail from './component/CaseStudyCompo/CaseStudydetail';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<App />}>
      <Route index path='/' element={<Home />} />
      <Route path='about-me' element={<AboutMe />} />

      <Route path='case-study' element={<CaseStudy />} />
      <Route path='case-study/:id' element={<CaseStudydetail />} />

      <Route path='dummy-projects' element={<DummyPro />} />
      <Route path='contact' element={<Contact />} />
    </Route>
  )
)


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
